import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy border-t border-white/[0.06] py-16 px-6" data-id="element-140">
      <div className="max-w-5xl mx-auto" data-id="element-141">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-142">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-143">
            <div className="flex items-center gap-2.5 mb-4" data-id="element-144">
              <img src="https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/logo-dark-trans.png" alt="Thruline" className="h-7 w-auto" data-id="element-145" />

            </div>
            <p className="text-white/40 text-sm leading-relaxed" data-id="element-146">
              Custom ERP software for manufacturing and operations companies.
            </p>
          </div>

          {/* Solutions */}
          <div data-id="element-147">
            <h4 className="text-white text-xs font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-148">
              Solutions
            </h4>
            <ul className="space-y-3" data-id="element-149">
              <li data-id="element-150">
                <Link to="/solutions" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-151">

                  All Solutions
                </Link>
              </li>
              <li data-id="element-152">
                <Link to="/pricing" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-153">

                  Pricing
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/resources/integrations" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-155">

                  Integrations
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-156">
            <h4 className="text-white text-xs font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-157">
              Resources
            </h4>
            <ul className="space-y-3" data-id="element-158">
              <li data-id="element-159">
                <Link to="/resources/blog" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-160">

                  Blog
                </Link>
              </li>
              <li data-id="element-161">
                <Link to="/resources/case-studies" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-162">

                  Case Studies
                </Link>
              </li>
              <li data-id="element-163">
                <Link to="/resources/thesis" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-164">

                  Our Thesis
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div data-id="element-165">
            <h4 className="text-white text-xs font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-166">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-167">
              <li data-id="element-168">
                <Link to="/about" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-169">

                  About Us
                </Link>
              </li>
              <li data-id="element-170">
                <Link to="/about/careers" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-171">

                  Careers
                </Link>
              </li>
              <li data-id="element-172">
                <Link to="/partners" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-173">

                  Become A Partner
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-174">
          <p className="text-white/30 text-xs" data-id="element-175">
            © 2026 Thruline. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-176">
            <Link to="/terms" className="text-white/30 text-xs hover:text-white/60 transition-colors" data-id="element-177">

              Terms & Conditions
            </Link>
            <Link to="/terms" className="text-white/30 text-xs hover:text-white/60 transition-colors" data-id="element-178">

              Privacy
            </Link>
            <a href="https://www.linkedin.com/company/thruline-hq/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 transition-colors" aria-label="LinkedIn" data-id="element-179">

              <LinkedinIcon className="w-4 h-4" data-id="element-180" />
            </a>
            <a href="#youtube" className="text-white/30 hover:text-white/60 transition-colors" aria-label="YouTube" data-id="element-181">

              <YoutubeIcon className="w-4 h-4" data-id="element-182" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}